import {
  FaCamera,
  FaCheckSquare,
  FaHeading,
  FaPhoneAlt,
  FaUser,
} from "react-icons/fa";
import { MdDateRange, MdEmail, MdGpsFixed } from "react-icons/md";
import { IoLocationSharp, IoTime } from "react-icons/io5";
import { PiSignature } from "react-icons/pi";
import { IoIosRadioButtonOn, IoMdQrScanner } from "react-icons/io";
import { RiDropdownList } from "react-icons/ri";
import { TbSquareRoundedNumber7Filled } from "react-icons/tb";
import { BiText } from "react-icons/bi";
import { CiBarcode } from "react-icons/ci";
import { LuSwitchCamera } from "react-icons/lu";
import { SignalHigh } from "lucide-react";
import translations from "../../components/common/Translations";
import { FaImages } from "react-icons/fa";

// Field types a safety-compliance sub-workflow is not allowed to use. A safety
// checklist is a plain sign-off form, so the device-capture fields (barcode scan,
// OCR, GPS, signal quality) are hidden from its palette and rejected on drop.
// Everything else in the palette stays available.
export const SAFETY_DISALLOWED_FIELD_TYPES = [
  "scan", // Barcode
  "ocr", // OCR
  "gps", // GPS
  "signal_quality", // Capture Signal Quality
];

export const ASPECT_RATIOS = [
  "Custom",
  "1:1",
  "4:3",
  "3:4",
  "16:9",
  "9:16",
  "3:2",
  "2:3",
  "5:4",
  "4:5",
];

export const Elements = [
  {
    value: "",
    fieldName: "Heading",
    icon: <FaHeading size={20} />,
    fieldType: "text",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Heading",
    validationValues: [],
    tooltip: "Use this to add a heading .",

  },
  {
    value: "",
    fieldName: "Name",
    icon: <FaUser size={20} />,
    fieldType: "text",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Name",
    validationValues: [],
    tooltip: "Enter the name for field.",
  },
  {
    value: "",
    fieldName: "Email",
    icon: <MdEmail size={20} />,
    fieldType: "email",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Email",
    validationValues: [],
    tooltip: "Enter a valid email address.",

  },
  {
    value: "",
    fieldName: "Phone",
    icon: <FaPhoneAlt size={20} />,
    fieldType: "number",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Phone",
    validationValues: [],
    tooltip: "Enter a phone number ",

  },
  {
    value: "",
    fieldName: "Address",
    icon: <IoLocationSharp size={20} />,
    fieldType: "text",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Address",
    validationValues: [],
    tooltip: "Enter the  address.",

  },
  {
    value: "",
    fieldName: "Date Picker",
    icon: <MdDateRange size={20} />,
    fieldType: "date",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Date Picker",
    validationValues: [],
    tooltip: "Select a date from the calendar.",

  },
  {
    value: "",
    fieldName: "Take Photo",
    icon: <FaCamera size={20} />,
    fieldType: "file",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Take Photo",
    validationValues: [],
    tooltip: "Upload a photo.",

  },
  {
    value: "",
    fieldName: "Signature",
    icon: <PiSignature size={20} />,
    fieldType: "text",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Signature",
    validationValues: [],
    tooltip: "Add a  signature.",

  },
  {
    value: "",
    fieldName: "Radio Button",
    icon: <IoIosRadioButtonOn size={20} />,
    fieldType: "radio",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Radio Button",
    validationValues: [],
    tooltip: "Choose one option from multiple choices.",

  },
  {
    value: "",
    fieldName: "Checkbox",
    icon: <FaCheckSquare size={20} />,
    fieldType: "checkbox",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Checkbox",
    validationValues: [],
    tooltip: "Select multiple options if applicable.",

  },
  {
    value: "",
    fieldName: "Dropdown",
    icon: <RiDropdownList size={20} />,
    fieldType: "select",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Dropdown",
    validationValues: [],
    tooltip: "Select an option from the dropdown list.",

  },
  {
    value: "",
    fieldName: "Number",
    icon: <TbSquareRoundedNumber7Filled size={20} />,
    fieldType: "number",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Number",
    validationValues: [],
    tooltip: "Enter a numerical value.",

  },
  {
    value: "",
    fieldName: "Time",
    icon: <IoTime size={20} />,
    fieldType: "time",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Time",
    validationValues: [],
    tooltip: "Pick a specific time.",

  },
  {
    value: "",
    fieldName: "Long Text",
    icon: <BiText size={20} />,
    fieldType: "textarea",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Long Text",
    validationValues: [],
    tooltip: "Enter detailed text or descriptions.",

  },
  {
    value: "",
    fieldName: "Barcode",
    icon: <CiBarcode size={20} />,
    fieldType: "scan",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Barcode",
    validationValues: [],
    tooltip: "Scan a barcode for input.",

  },
  {
    value: "",
    fieldName: "OCR",
    icon: <LuSwitchCamera size={20} />,
    fieldType: "ocr",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    allowGallery: true,
    cloneName: "OCR",
    validationValues: [],
    tooltip: "Optical Character Recognition",
  },
  {
    value: "",
    fieldName: "GPS",
    icon: <MdGpsFixed size={20} />,
    fieldType: "gps",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "GPS",
    validationValues: [],
    tooltip: "Global Positioning System",
  },
  {
    value: "",
    fieldName: "Capture Signal Quality",
    icon: <SignalHigh size={20} />,
    fieldType: "signal_quality",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Capture Signal Quality",
    validationValues: [],
    tooltip: "Automatically captures the device's network signal quality.",
  },
  // {
  //   value: "",
  //   fieldName: "Scanning",
  //   icon: <IoMdQrScanner />,
  //   fieldType: "text",
  //   isMandatory: false,
  //   isReport: false,
  //   isPdf: false,
  //   cloneName: "Scanning",
  //   validationValues: [],
  // },
];

export const getElements = (langMode) => [
  {
    value: "",
    fieldName: translations[langMode].Heading,
    icon: <FaHeading size={20} />,
    fieldType: "text",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Heading",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipHeading,

  },
  {
    value: "",
    fieldName: translations[langMode].Name,
    icon: <FaUser size={20} />,
    fieldType: "text",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Name",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipName,
  },
  {
    value: "",
    fieldName: translations[langMode].Email,
    icon: <MdEmail size={20} />,
    fieldType: "email",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Email",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipEmail,

  },
  {
    value: "",
    fieldName: translations[langMode].Phone,
    icon: <FaPhoneAlt size={20} />,
    fieldType: "number",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Phone",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipPhone,

  },
  {
    value: "",
    fieldName: translations[langMode].Address,
    icon: <IoLocationSharp size={20} />,
    fieldType: "text",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Address",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipAddress,

  },
  {
    value: "",
    fieldName: translations[langMode].DatePicker,
    icon: <MdDateRange size={20} />,
    fieldType: "date",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Date Picker",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipDate,

  },
  {
    value: "",
    fieldName: translations[langMode].TakePhoto,
    icon: <FaCamera size={20} />,
    fieldType: "file",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    allowGallery: true,
    cloneName: "Take Photo",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipPhoto,

  },
  {
    value: null,
    fieldName: translations[langMode].MultipleImages,
    icon: <FaImages size={20} />,
    fieldType: "multi_image",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    allowGallery: true,
    cloneName: "Multiple Images",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipMultiImage,
    multiple: true,
    accept: "image/*",
  },
  {
    value: "",
    fieldName: translations[langMode].Signature,
    icon: <PiSignature size={20} />,
    fieldType: "text",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Signature",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipSignature,

  },
  {
    value: "",
    fieldName: translations[langMode].RadioButton,
    icon: <IoIosRadioButtonOn size={20} />,
    fieldType: "radio",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Radio Button",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipRadio,

  },
  {
    value: "",
    fieldName: translations[langMode].Checkbox,
    icon: <FaCheckSquare size={20} />,
    fieldType: "checkbox",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Checkbox",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipCheckbox,

  },
  {
    value: "",
    fieldName: translations[langMode].Dropdown,
    icon: <RiDropdownList size={20} />,
    fieldType: "select",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Dropdown",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipDropdown,

  },
  {
    value: "",
    fieldName: translations[langMode].Number,
    icon: <TbSquareRoundedNumber7Filled size={20} />,
    fieldType: "number",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Number",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipNumber,

  },
  {
    value: "",
    fieldName: translations[langMode].Time,
    icon: <IoTime size={20} />,
    fieldType: "time",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Time",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipTime,

  },
  {
    value: "",
    fieldName: translations[langMode].LongText,
    icon: <BiText size={20} />,
    fieldType: "textarea",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Long Text",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipLongText,

  },
  {
    value: "",
    fieldName: translations[langMode].Barcode,
    icon: <CiBarcode size={20} />,
    fieldType: "scan",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Barcode",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipBarcode,

  },

  {
    value: "",
    fieldName: translations[langMode].OCR,
    icon: <LuSwitchCamera size={20} />,
    fieldType: "ocr",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    allowGallery: true,
    cloneName: "OCR",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipOcr,
  },
  {
    value: "",
    fieldName: translations[langMode].GPS,
    icon: <MdGpsFixed size={20} />,
    fieldType: "gps",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "GPS",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipGps,
  },
  {
    value: "",
    fieldName: translations[langMode].CaptureSignalQuality,
    icon: <SignalHigh size={20} />,
    fieldType: "signal_quality",
    isMandatory: false,
    isReport: false,
    isPdf: false,
    cloneName: "Capture Signal Quality",
    validationValues: [],
    tooltip: translations[langMode].wfElTooltipSignalQuality,
  },
];


export const Translations = {
  en: {
    workflow: "Workflow Maker",
    entername: " Enter name",
    title: "PDF Title",
    enterPDFTitle: "Enter PDF Title",
    enterWorkflowName: "Enter workflow name",
    selectTimer: "Select Timer",
    element: "Elements",
    parameter: "Parameters",
    mandatory: "Mandatory",
    excel: "Excel",
    pdf: "PDF",
    selectoption: " Select Option",
    editInputvalue: "Edit Input Values",
    selectedOption: " Selected Option",
    Que: "Que",
    option: "Option",
    addremove: "Add/Remove Options",
    clone: "Clone",
    update: "Update",
    Submit: "Submit",
    preview: "Preview",
    maximumLocationAccuracy : "Maximum Location Accuracy", // update by harshit
  },
  ar: {
    workflow: "صانع سير العمل",
    entername: "أدخل الأسم",
    title: "PDF عنوان",
    enterPDFTitle: "PDF أدخل عنوان",
    enterWorkflowName: "أدخل أسم سير العمل",
    selectTimer: "حدد الموقت",
    element: "عناصر",
    parameter: "حدود",
    mandatory: "إلزامي",
    excel: "اكسل",
    pdf: "قوات الدفاع الشعبي",
    selectoption: "حدد الخيار",
    editInputvalue: "تحرير قيم الإدخال",
    selectedOption: " الخيار المحدد:",
    Que: "سؤال",
    option: "خيار",
    addremove: "إضافة/إزالة الخيارات",
    clone: "استنساخ",
    update: "تحديث",
    Submit: "يُقدِّم",
    preview: "معاينة",
    maximumLocationAccuracy : "أقصى دقة في تحديد الموقع", // update by harshit
  },
  ur: {
    workflow: "ورک فلو بنانے والا",
    entername: " نام درج کریں۔",
    title: "عنوان",
    enterPDFTitle: "پی ڈی ایف ٹائٹل درج کریں۔",
    enterWorkflowName: "ورک فلو کا نام درج کریں۔",
    selectTimer: "ٹائمر منتخب کریں۔",
    element: "عناصر",
    parameter: "پیرامیٹرز",
    mandatory: "لازمی",
    excel: "لازمی",
    pdf: "PDF",
    selectoption: " اختیار منتخب کریں۔",
    editInputvalue: "ان پٹ ویلیوز میں ترمیم کریں۔",
    selectedOption: " منتخب کردہ آپشن",
    Que: "سوالات",
    option: "آپشن",
    addremove: "اختیارات شامل کریں/ہٹائیں۔",
    clone: "کلون",
    update: "اپ ڈیٹ کریں۔",
    Submit: "جمع کروائیں۔",
    preview: "پیش نظارہ",
    maximumLocationAccuracy : "زیادہ سے زیادہ مقام کی درستگی", // update by harshit
  },
};


export const Parameters = [
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Account number",
    fieldType: "text",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Visit time",
    fieldType: "time",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "GIS X, GIS Y",
    fieldType: "text",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Meter Number",
    fieldType: "text",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Type of Meter",
    fieldType: "text",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Outstanding Due",
    fieldType: "number",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Priority",
    fieldType: "text",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Status",
    fieldType: "text",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Address",
    fieldType: "text",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Consumer Name",
    fieldType: "text",
  },
  {
    isReport: false,
    isMandatory: false,
    fieldName: "Consumer Mobile",
    fieldType: "number",
  },
];